"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RADIUS = exports.radiusOptions = void 0;
exports.radiusOptions = [
    {
        label: '500m',
        value: '500',
    },
    {
        label: '1km',
        value: '1000',
    },
    {
        label: '2km',
        value: '2000',
    },
    {
        label: '5km',
        value: '5000',
    },
    {
        label: '10km',
        value: '10000',
    },
];
exports.DEFAULT_RADIUS = 10000;
//# sourceMappingURL=MapRadiusSearch.constants.js.map